module.exports = __webpack_public_path__ + "img/42_14.a77b3311.png";